var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoondark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55268 9.05971C3.55268 9.48658 3.61875 9.90329 3.74071 10.2895C1.78929 9.61363 0.315553 7.81974 0.163098 5.72094C0.0106426 3.49001 1.29635 1.40646 3.37482 0.532386C3.91349 0.308785 4.18791 0.471404 4.30479 0.588286C4.41659 0.700086 4.57413 0.969424 4.35053 1.48269C4.12185 2.0112 4.01005 2.5702 4.01005 3.14953C4.01513 4.18623 4.42168 5.14669 5.08232 5.88356C4.15234 6.62551 3.55268 7.774 3.55268 9.05971Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.75766 8.40916C8.75145 9.77617 7.15576 10.5791 5.45334 10.5791C5.37203 10.5791 5.29072 10.574 5.20941 10.5689C4.70123 10.5486 4.20829 10.4521 3.74076 10.2894C3.6188 9.90322 3.55273 9.48651 3.55273 9.05963C3.55273 7.77393 4.15239 6.62543 5.08237 5.88348C5.8294 6.72199 6.90166 7.26574 8.08573 7.31656C8.40589 7.33181 8.72604 7.3064 9.04112 7.2505C9.61028 7.14886 9.83897 7.3623 9.92028 7.49951C10.0067 7.63672 10.0981 7.93655 9.75766 8.40916Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoondark);
export default __webpack_public_path__ + "static/media/moondark.4817c94cc830693d397d3f6d0c674b32.svg";
export { ForwardRef as ReactComponent };